module.exports = require("./mn-MN");